import Toast from 'react-native-toast-message';
import i18n from '../shared/i18n';

export const ToastNotifications = {
  displaySuccessNotification: (
    message: string = i18n.t('toastMessages.successDefaultMessage'),
  ) => {
    Toast.show({
      type: 'success',
      text1: i18n.t('toastMessages.success'),
      text1Style: { fontSize: 16 },
      text2: message,
      text2Style: { fontSize: 14 },
    });
  },
  displayErrorNotification: (
    message: string = i18n.t('toastMessages.errorDefaultMessage'),
  ) => {
    Toast.show({
      type: 'error',
      text1: i18n.t('toastMessages.error'),
      text2: message,
      text1Style: { fontSize: 16 },
      text2Style: { fontSize: 14 },
    });
  },
};
